import { CountryCode } from '@constants'
import { getCountryCodeFromPathname } from '@utils/getCountryCodeFromPathname'
import { match } from 'path-to-regexp'

export const HOME_AB_TEST_EXPERIMENT_PREFIX = 'home_ab_test'
export const PRODUCT_AB_TEST_EXPERIMENT_PREFIX = 'product_ab_test_'

const COUNTRY_PREFIX_REGEX = new RegExp(`^/(${Object.values(CountryCode).join('|')})(?=/|$)`, 'i')
const matchProductPage = match('{/:countryCode}/product/:productKey')

export function getAbTestExperimentPrefix(pathname: string, productId?: number) {
  const path = pathname.replace(COUNTRY_PREFIX_REGEX, '')
  const countryCode = getCountryCodeFromPathname(pathname, CountryCode.TW).toLowerCase()
  if (path === '' || path === '/') {
    return `${HOME_AB_TEST_EXPERIMENT_PREFIX}_${countryCode}`
  }
  if (matchProductPage(pathname) && productId) {
    return `${PRODUCT_AB_TEST_EXPERIMENT_PREFIX}${countryCode}_${productId}`
  }
  return null
}
